export default __webpack_public_path__ + "static/media/Hubista-Twitter-share.c609ee7a.png";